import { actions } from "@ehi/global-marketing-interface";

export const updateCommitState = (gmiStateKey, value) => (dispatch) =>
    dispatch(actions.reservations.commitState.set(gmiStateKey, { [gmiStateKey]: value }));